 

export const initialState = {
    // user: sessionUser,
    deliveryFees: 70,
    prices:[],
    foodItems: [],
    showCart: false,
    showContactForm: false,
    cartItems: [],
    cartTotal: 0,
    // adminMode: sessionUserMode,
    location:null,
    formattedLocation:'',
    users: [],
    paymentMethod: 'mobile_money',
    checkoutData: {},
    products: null,
    categories: [],
    sections: []
}